export const dashboardActions = {
    GET_DASHBOARD_DEPLOY_STATUS: 'GET_DASHBOARD_DEPLOY_STATUS',
    SET_DASHBOARD_DEPLOY_STATUS: 'GET_DASHBOARD_DEPLOY_STATUS',
    GET_DASHBOARD_AVERAGE_DEPLOY: 'GET_DASHBOARD_AVERAGE_DEPLOY',
    SET_DASHBOARD_AVERAGE_DEPLOY: 'SET_DASHBOARD_AVERAGE_DEPLOY',
    GET_DASHBOARD_MOST_ACTIVE_PROJECTS: 'GET_DASHBOARD_MOST_ACTIVE_PROJECTS',
    SET_DASHBOARD_MOST_ACTIVE_PROJECTS: 'SET_DASHBOARD_MOST_ACTIVE_PROJECTS',
    GET_DASHBOARD_PROJECTS: 'GET_DASHBOARD_PROJECTS',
    SET_DASHBOARD_PROJECTS: 'SET_DASHBOARD_PROJECTS',
    GET_DASHBOARD_MY_PROJECTS: 'GET_DASHBOARD_MY_PROJECTS',
    SET_DASHBOARD_MY_PROJECTS: 'SET_DASHBOARD_MY_PROJECTS',
    GET_TIME_PERIODS: 'GET_TIME_PERIODS',
    SET_TIME_PERIODS: 'SET_TIME_PERIODS',
    GET_FILTER: 'GET_FILTER'
};

const initState = {};

export const dashboardReducer = (state = initState, action: any) => {
    switch (action.type) {
        case dashboardActions.SET_DASHBOARD_DEPLOY_STATUS:
            return Object.assign({}, state, action.payload);

        case dashboardActions.SET_DASHBOARD_AVERAGE_DEPLOY:
            return Object.assign({}, state, action.payload);

        case dashboardActions.SET_DASHBOARD_MOST_ACTIVE_PROJECTS:
            return Object.assign({}, state, action.payload);

        case dashboardActions.SET_DASHBOARD_PROJECTS:
            return Object.assign({}, state, action.payload);

        case dashboardActions.SET_DASHBOARD_MY_PROJECTS:
            return Object.assign({}, state, action.payload);

        case dashboardActions.SET_TIME_PERIODS:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/dashboardReducer.ts